import React, { useEffect, useState } from "react";
import { GlobalContextType, GlobalContext } from "./GlobalContext";
import { useLocation } from "react-router-dom";

interface GlobalContextProps {
  children: React.ReactNode | null;
}

export const GlobalContextProvider = (props: GlobalContextProps) => {
  const location = useLocation();
  const [headerColor, setHeaderColor] = useState(
    (location.pathname === "/infinite-50" && "white") ||
      (location.pathname === "/infinite-110" && "gray"),
  );

  const changeHeaderColor = (value: string) => {
    setHeaderColor(value);
  };

  useEffect(() => {
    if (location.pathname === "/infinite-50") {
      changeHeaderColor("white");
    } else if (location.pathname === "/infinite-110") {
      changeHeaderColor("gray");
    } else {
      changeHeaderColor("black");
    }
  }, [location.pathname]);

  const context: GlobalContextType = {
    headerColor,
    changeHeaderColor,
  };

  return (
    <GlobalContext.Provider value={context}>
      {props.children}
    </GlobalContext.Provider>
  );
};
